<section class="text-gray-600 body-font">
  <div class="container md:pt-6 pb-24 px-5 mx-auto flex flex-col">

      <div class="flex flex-col md:flex-row mt-6">
        <div class="md:w-2/3 mt-2 md:pl-4 text-center md:text-left">
          <h1 class="text-3xl font-medium title-font text-gray-900 mb-10 w-full">Schau bei uns rein!</h1>
          <div class="flex flex-col md:flex-row justify-start md:items-end">
            <div class="">
              <p class="w-full text-xl mb-0 font-bold">ACA Brazilian Jiu-Jitsu</p>
              <p class="w-full text-xl mb-0 font-bold">Wallisellenstrasse 301a</p>
              <p class="w-full text-xl mb-2 font-bold">8050 Zürich</p>
              <p class="w-full text-lg mb-0">+41 79 331 80 01</p>
              <p class="w-full text-lg mb-0">info&#64;acabjj.ch</p>
            </div>
            <div class="mt-4 md:pl-16 md:pr-4">
              <p class="text-xl w-full mb-2">Anfahrt</p>
              <p class="text-lg w-full">Bus: 61, 62, 94 - Haltestelle Saatlenstrasse</p>
              <p class="text-lg w-full">Auto: zahlreiche Parkplätze vorhanden</p>
            </div>
          </div>
        </div>
        <div class="md:w-1/3 md:border-l border-gray-200 md:border-t-0 border-t mt-4 md:mt-0 pt-4 md:pt-0">
          <div class="flex flex-col justify-center items-center w-full">
            <a href="https://www.instagram.com/aca.bjj/" rel="noopener noreferrer" target="_blank" class="object-cover object-center w-1/2">
              <img src="/assets/img/insta_qrcode_1.png" alt="acabjj instagram qrcode" width="585" height="585">
            </a>
            <div>
              <a href="https://www.instagram.com/aca.bjj/" rel="noopener noreferrer" target="_blank" class="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-5 h-5 mr-2">
                  <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                  <path fill="currentColor"
                        d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
                </svg>
                <span>aca.brazilianjiujitsu</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="rounded-lg mt-16">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2700.0460008509085!2d8.559416677377877!3d47.411043901459905!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479aa07ba8ad5001%3A0x5a27f62c90357b7e!2sWallisellenstrasse%20301A%2C%208050%20Z%C3%BCrich!5e0!3m2!1sen!2sch!4v1668782752236!5m2!1sen!2sch"
                width="100%"
                height="600"
                style="border:0;"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade">
        </iframe>
      </div>

    <div class="flex flex-col md:flex-row mt-24">
      <div class="md:w-1/3">
        <div class="flex flex-col justify-center items-center w-full">
          <picture class="object-cover object-center w-3/5 rounded">
            <source type="image/webp" srcset="/assets/img/contact_ando_1.webp">
            <source type="image/png" srcset="/assets/img/contact_ando_1.jpg">
            <img class="rounded" src="/assets/img/contact_ando_1.webp" alt="acabjj ando cardoso" width="1000" height="1000">
          </picture>
          <span class="font-fondamento">Ando Cardoso</span>
        </div>
      </div>
      <div class="md:w-3/5 md:border-l border-gray-200 md:border-t-0 border-t pl-0 md:pl-10 mt-4 md:mt-0 pt-4 md:pt-0 text-center md:text-left">
        <h2 class="text-xl font-bold mb-4">Kontaktiere uns noch heute, um eine kostenlose Probelektion zu vereinbaren!</h2>
        <p class="text-xl mb-8">Schicke uns einfach eine kurze Nachricht auf Whatsapp oder per E-Mail, wir melden uns schnellstmöglich bei Dir!</p>
        <a routerLink="/message"
             class="p-1.5 trial-lesson-button bg-orange-800 hover:bg-amber-700 text-gray-50 font-bold">
            Gratis Probetraining
        </a>
      </div>
    </div>

  </div>
</section>
